import './App.css';
import HmacCalculator from './components/HmacCalculator';

function App() {
  return (
    <div className="container">
      <HmacCalculator/>
    </div>
  );
}

export default App;
